import { render, staticRenderFns } from "./ClearAlerts.vue?vue&type=template&id=84b1e9d2"
import script from "./ClearAlerts.vue?vue&type=script&lang=js"
export * from "./ClearAlerts.vue?vue&type=script&lang=js"
import style0 from "./ClearAlerts.vue?vue&type=style&index=0&id=84b1e9d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports